import { game_id } from "@/utils/const";
export default [
  {
    wandEvent: "show",
    event: "p_pull_p_home_page",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_vshow",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
      },
    }),
  },
  {
    wandEvent: "media",
    event: "p_pull_p_top_media_btn",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
      },
    }),
  },
  {
    wandEvent: "login",
    event: "p_pull_p_register_submit_btn",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
          tel: "$user_hp",
          first_privacy: "$privacyAgree",
          second_privacy: "$above18Agree",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
        tel: "$user_hp",
        first_privacy: "$privacyAgree",
        second_privacy: "$above18Agree",
      },
    }),
  },
  {
    wandEvent: "loginResult",
    event: "p_pull_p_tel_register_ret",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
          tel: "$user_hp",
          first_privacy: "$privacyAgree",
          second_privacy: "$above18Agree",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
        tel: "$user_hp",
        first_privacy: "$privacyAgree",
        second_privacy: "$above18Agree",
      },
    }),
  },
  {
    wandEvent: "verify",
    event: "p_pull_p_verify_code_btn",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
          tel: "$user_hp",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
        tel: "$user_hp",
      },
    }),
  },
  {
    wandEvent: "registerFriend",
    event: "p_pull_p_friend_code_btn",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
          tel: "$user_hp",
          visit_code: "$in_code",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
        tel: "$user_hp",
        visit_code: "$in_code",
      },
    }),
  },
  {
    wandEvent: "registerResult",
    event: "p_pull_p_friend_code_ret",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
          tel: "$user_hp",
          visit_code: "$in_code",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
        tel: "$user_hp",
        visit_code: "$in_code",
      },
    }),
  },
  {
    wandEvent: "share",
    event: "p_pull_p_share_btn",
    params: JSON.stringify({
      tlog: {
        sub_action: "cm_click",
        ext_content: {
          url: "$window.location.href",
          client_type: "$userAgentInfo.os.name",
        },
        original_game_id: game_id,
      },
      google: {
        url: "$window.location.href",
        client_type: "$userAgentInfo.os.name",
      },
    }),
  },
];
